import { roundToDecimals } from '@ps/utils';

export function averageCpi(currentCost: number, fielded: number): number {
  if (!fielded || !currentCost) return 0;
  return roundToDecimals(currentCost / fielded);
}
